module.exports = __webpack_public_path__ + "img/aca_27.22508893.png";